var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _g2, _g3, _g4, _g5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrowseMarketplace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 101,
    viewBox: "0 0 121 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.3792 66.1459C47.0154 66.1284 47.5542 66.9302 47.5814 67.937C47.6095 68.9436 47.1171 69.7748 46.4809 69.7923C45.8447 69.8098 45.3068 69.0078 45.2787 68.0012C45.2504 66.9937 45.744 66.1632 46.3792 66.1459Z",
    fill: "#1E0545"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9212 67.3376C44.3953 67.287 44.8437 67.8453 44.9208 68.583C44.999 69.3214 44.6771 69.9608 44.2028 70.0104C43.7285 70.06 43.2803 69.5027 43.203 68.764C43.125 68.0266 43.446 67.3874 43.9212 67.3376Z",
    fill: "#1E0545"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.999 68.1523C42.9858 68.0479 43.2277 70.3392 42.2409 70.4436C41.2549 70.5469 41.0132 68.2565 41.999 68.1523Z",
    fill: "#1E0545"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3952 70.2475C41.7085 71.4223 40.5954 71.7189 40.282 70.5441C39.9687 69.3694 41.0818 69.0728 41.3952 70.2475Z",
    fill: "#1E0545"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3658 71.3005C40.6298 72.2902 39.6556 72.5501 39.3915 71.5604C39.1277 70.5716 40.102 70.3117 40.3658 71.3005Z",
    fill: "#1E0545"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6316 71.4476C47.4132 70.7577 46.4581 70.2961 45.3247 70.3862C45.2311 70.4058 45.1554 70.3968 45.0609 70.4166C44.9853 70.4075 44.8917 70.4272 44.7923 70.424C44.5524 70.4494 44.3176 70.4987 44.1065 70.5429C40.8493 71.0295 40.1386 74.0723 40.2446 74.8107C40.1961 75.6303 41.0466 77.5852 41.0466 77.5852C41.0466 77.5852 43.188 80.6669 43.2422 81.3912C43.2963 82.1155 43.4612 82.669 43.6533 83.1192C43.8897 83.7804 44.394 84.3126 45.0362 84.5707L45.094 84.6084C45.3346 84.7054 45.5096 84.7176 45.5096 84.7176C45.7403 84.7669 45.9851 84.7654 46.2487 84.7341C47.5602 84.5568 48.4763 83.3111 48.294 81.9757C48.188 81.2373 47.7636 80.6156 47.1714 80.2493C44.5099 77.9623 45.6024 76.0417 45.6024 76.0417C48.0306 73.8161 48.0537 72.2912 47.6316 71.4476Z",
    fill: "#1E0545"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_45295)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 26.2476,
    width: 24.9909,
    height: 12.1049,
    fill: "#C9BDD9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 38.3525,
    width: 24.9909,
    height: 12.1049,
    fill: "#6140A5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 50.4575,
    width: 24.9909,
    height: 25.7718,
    fill: "#1E0545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 50.4575H76.4909V64.5149C76.4909 66.2401 75.0923 67.6387 73.367 67.6387H54.6239C52.8986 67.6387 51.5 66.2401 51.5 64.5149V50.4575Z",
    fill: "#1E0545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5 50.4575H76.4909V57.4862C76.4909 59.2115 75.0923 60.6101 73.367 60.6101H54.6239C52.8986 60.6101 51.5 59.2115 51.5 57.4862V50.4575Z",
    fill: "#1E0545"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 51H32.6525H42.8051H52.9576H63.1101H73.2627H83.4152H93.5677H103.72",
    stroke: "#A5B7BF",
    strokeWidth: 1.24954,
    strokeDasharray: "4.37 4.37"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_115_45295)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.059,
    y: 66,
    width: 16.3459,
    height: 16.3459,
    rx: 2.09739,
    transform: "rotate(45 102.059 66)",
    fill: "#F1F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.7102 74.1729L98.5449 75.7766H100.577L100.711 74.1729H98.7102ZM101.076 74.1729L100.942 75.7766H103.049L102.915 74.1729H101.076ZM103.28 74.1729L103.411 75.7766H105.443L105.278 74.1729H103.28ZM98.5108 76.1329L98.3625 77.5584H100.432L100.549 76.1329H98.5108ZM100.914 76.1329L100.797 77.5584H103.194L103.077 76.1329H100.914ZM103.442 76.1329L103.559 77.5584H105.626L105.477 76.1329H103.442ZM98.3284 77.9148L98.1631 79.5185H100.27L100.404 77.9148H98.3284ZM100.766 77.9148L100.634 79.5185H103.357L103.226 77.9148H100.766ZM103.588 77.9148L103.722 79.5185H105.825L105.66 77.9148H103.588ZM101.812 79.6967V80.944H102.177V79.6967H101.812ZM100.717 81.1222V81.835H103.271V81.1222H100.717Z",
    fill: "#0A3751"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_115_45295)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45.9932,
    y: 16,
    width: 24.7397,
    height: 24.7397,
    rx: 3.17442,
    transform: "rotate(45 45.9932 16)",
    fill: "#F1F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.8231 30.6142C45.4427 30.6142 45.9454 30.1115 45.9454 29.4919C45.9454 28.8723 45.4427 28.3696 44.8231 28.3696C44.2035 28.3696 43.7008 28.8723 43.7008 29.4919C43.7008 30.1115 44.2035 30.6142 44.8231 30.6142ZM45.4038 33.1204C47.1426 31.8492 49.2001 31.1755 51.3702 31.1755L52.1184 31.1754V37.722C52.1184 38.9568 51.1086 39.9666 49.8738 39.9666H42.392C41.1572 39.9666 40.1475 38.9568 40.1475 37.722V31.9236H41.6438C43.0278 31.9609 44.3188 32.3912 45.4038 33.1204ZM50.622 32.7092C49.1629 32.8407 47.7972 33.3266 46.5814 34.131L46.5816 34.131C46.9557 34.5051 47.2925 34.9354 47.5548 35.4023C48.4901 34.7849 49.5187 34.3926 50.622 34.2428V32.7092ZM45.5154 38.4703H47.0308H47.0309C46.7684 35.7018 44.4685 33.5136 41.6438 33.42V34.9164C43.645 35.0099 45.2721 36.5254 45.5154 38.4703ZM41.6437 36.4318V37.7221L41.6437 37.722C41.6437 38.1334 41.9805 38.4702 42.3918 38.4702H44.019C43.7756 37.367 42.8032 36.5063 41.6437 36.4318ZM48.5454 38.4703H49.8737L49.8737 38.4703C50.285 38.4703 50.6219 38.1335 50.6409 37.7222L50.6401 35.7391C49.7612 35.8889 48.9377 36.2447 48.2085 36.7869C48.3773 37.329 48.5081 37.8901 48.5454 38.4703Z",
    fill: "#0A3751"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_115_45295)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 28.9932,
    y: 47,
    width: 24.7397,
    height: 24.7397,
    rx: 3.17442,
    transform: "rotate(45 28.9932 47)",
    fill: "#F1F8FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2842 58.5972C29.2842 58.5972 31.2172 61.7674 31.2172 62.8495C31.2172 63.9323 30.3663 64.7825 29.2842 64.7825C28.2014 64.7825 27.3512 63.9316 27.3512 62.8495C27.3512 61.7666 29.2842 58.5972 29.2842 58.5972ZM33.9228 65.5558C33.5361 65.5558 33.1496 65.7491 32.7631 65.9424C32.3766 66.1358 31.9901 66.3291 31.6035 66.3291C31.2168 66.3291 30.8303 66.1358 30.4438 65.9424C30.0573 65.7491 29.6708 65.5558 29.2842 65.5558C28.8975 65.5558 28.511 65.7491 28.1245 65.9424C27.738 66.1358 27.3515 66.3291 26.9649 66.3291C26.5782 66.3291 26.1917 66.1358 25.8052 65.9424C25.4187 65.7491 25.0322 65.5558 24.6456 65.5558C24.2572 65.5558 23.8453 65.7638 23.4463 65.9654L23.4463 65.9654C23.3293 66.0245 23.2135 66.083 23.0996 66.1356V67.6815C23.2135 67.629 23.3293 67.5704 23.4463 67.5113C23.8453 67.3098 24.2572 67.1017 24.6456 67.1017C25.0322 67.1017 25.4187 67.295 25.8052 67.4884C26.1917 67.6817 26.5782 67.8751 26.9649 67.8751C27.3515 67.8751 27.738 67.6817 28.1245 67.4884L28.1245 67.4884C28.511 67.295 28.8975 67.1017 29.2842 67.1017C29.6708 67.1017 30.0573 67.295 30.4438 67.4884L30.4438 67.4884C30.8303 67.6817 31.2168 67.8751 31.6035 67.8751C31.9901 67.8751 32.3766 67.6817 32.7631 67.4884C33.1496 67.295 33.5361 67.1017 33.9228 67.1017C34.3112 67.1017 34.723 67.3098 35.122 67.5113C35.239 67.5704 35.3549 67.629 35.4687 67.6815V66.1356C35.3549 66.083 35.239 66.0245 35.122 65.9654C34.723 65.7638 34.3112 65.5558 33.9228 65.5558ZM31.6035 69.4209C31.2168 69.4209 30.8303 69.2275 30.4438 69.0342L30.4438 69.0342C30.0573 68.8409 29.6708 68.6475 29.2842 68.6475C28.8975 68.6475 28.511 68.8409 28.1245 69.0342L28.1245 69.0342C27.738 69.2275 27.3515 69.4209 26.9649 69.4209C26.5782 69.4209 26.1917 69.2275 25.8052 69.0342C25.4187 68.8409 25.0322 68.6475 24.6456 68.6475C24.2572 68.6475 23.8453 68.8556 23.4463 69.0571C23.3293 69.1162 23.2135 69.1748 23.0996 69.2273V70.7733C23.2135 70.7207 23.3293 70.6622 23.4463 70.6031C23.8453 70.4015 24.2572 70.1935 24.6456 70.1935C25.0322 70.1935 25.4187 70.3868 25.8052 70.5801C26.1917 70.7735 26.5782 70.9668 26.9649 70.9668C27.3515 70.9668 27.738 70.7735 28.1245 70.5801L28.1245 70.5801L28.1245 70.5801C28.511 70.3868 28.8975 70.1935 29.2842 70.1935C29.6708 70.1935 30.0573 70.3868 30.4438 70.5801C30.8303 70.7735 31.2168 70.9668 31.6035 70.9668C31.9901 70.9668 32.3766 70.7735 32.7631 70.5801C33.1496 70.3868 33.5361 70.1935 33.9228 70.1935C34.3112 70.1935 34.723 70.4015 35.122 70.6031L35.1221 70.6031C35.239 70.6622 35.3549 70.7207 35.4687 70.7733V69.2273C35.3549 69.1748 35.239 69.1162 35.122 69.0571C34.723 68.8556 34.3112 68.6475 33.9228 68.6475C33.5361 68.6475 33.1496 68.8409 32.7631 69.0342C32.3766 69.2275 31.9901 69.4209 31.6035 69.4209Z",
    fill: "#0A3751"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_115_45295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.0062 15.4301C89.7107 15.1327 89.2261 15.2595 89.1357 15.6841C88.7438 17.59 87.4341 19.1074 85.5643 19.7236L83.1899 20.5061C80.0438 21.5428 78.3325 24.9364 79.3693 28.0825C79.4377 28.2903 79.5062 28.498 79.6043 28.696C81.0539 26.7048 83.403 24.6474 87.2911 23.3661C87.5286 23.2879 87.8442 23.4471 87.9225 23.6845C88.0105 23.9516 87.8415 24.2376 87.6041 24.3159C80.1247 26.7806 78.4947 32.4178 78.3399 34.3443C78.2984 34.9173 78.7119 35.3733 79.2552 35.4246C79.8282 35.4661 80.2842 35.0526 80.3355 34.5092C80.3557 34.3709 80.4893 32.8792 81.5824 31.1041C82.9922 32.0873 85.2135 32.7372 87.5295 31.6779C92.0817 29.8158 93.9971 24.5453 92.3148 19.4403C91.8258 17.9563 90.9907 16.5206 90.0062 15.4301Z",
    fill: "#6140A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_115_45295",
    x: 82.5,
    y: 60,
    width: 39.1162,
    height: 39.1167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_45295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_115_45295",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_115_45295",
    x: 20.5,
    y: 10,
    width: 50.9873,
    height: 50.9873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_45295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_115_45295",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_115_45295",
    x: -0.5,
    y: 39,
    width: 58.9873,
    height: 58.9873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_115_45295"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_115_45295",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_45295"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 51.5,
    y: 26.2476,
    width: 24.9909,
    height: 49.9817,
    rx: 3.12386,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_115_45295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(69.6016 17.6138) rotate(-18.2391)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowseMarketplace);
export default __webpack_public_path__ + "static/media/browse-marketplace.8820c47e8c4766e3506a4343d2733d8a.svg";
export { ForwardRef as ReactComponent };